import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Store } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";
import { t } from "../lib/i18n";
import { partnerApi, setPartnerToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const PartnerLoginPage = () => {
  const { tr } = useLang();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await partnerApi.post("/retailers/login", { mobile: mobile.trim(), password });
      setPartnerToken(res.data.token);
      localStorage.setItem("ap_partner", JSON.stringify(res.data.retailer));
      toast.success(tr({ en: "Signed in", hi: "साइन इन" }));
      navigate("/partner");
    } catch (err) {
      toast.error(err?.response?.data?.detail || tr({ en: "Login failed", hi: "लॉगिन असफल" }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="partner-login-page" className="max-w-md mx-auto px-4 lg:px-8 py-16">
      <div className="rounded-xl bg-white border border-slate-200 p-8">
        <div className="w-12 h-12 rounded-md bg-teal-50 text-teal-700 flex items-center justify-center mb-5">
          <Store className="w-6 h-6" />
        </div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900">{tr(t.partner.login)}</h1>
        <p className="mt-1 text-sm text-slate-600">
          {tr({ en: "B2B retailer / partner access only.", hi: "केवल B2B रिटेलर / पार्टनर हेतु।" })}
        </p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-sm">{tr(t.common.mobile)}</Label>
            <Input inputMode="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} className="mt-1.5" data-testid="partner-login-mobile" />
          </div>
          <div>
            <Label className="text-sm">{tr(t.admin.password)}</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="partner-login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-teal-700 hover:bg-teal-800 text-white" data-testid="partner-login-submit">
            {loading ? tr(t.common.submitting) : tr(t.admin.signin)}
          </Button>
          <p className="text-center text-sm text-slate-500">
            {tr({ en: "New here?", hi: "नए हैं?" })}{" "}
            <Link to="/partner/register" className="text-teal-700 hover:underline">{tr(t.partner.register)}</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default PartnerLoginPage;
